import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Button,
  Typography,
  useTheme,
} from '@mui/material';
import { useTranslation } from 'react-i18next';

interface RecommendedTargetGroupMissingModalProps {
  open: boolean;
  onClose: () => void;
}

export default function RecommendedTargetGroupMissingModal({
  open,
  onClose,
}: RecommendedTargetGroupMissingModalProps) {
  const { t } = useTranslation();
  const theme = useTheme();

  return (
    <Dialog
      open={open}
      onClose={(_event, reason) => {
        if (reason === 'backdropClick' || reason === 'escapeKeyDown') {
          return;
        }
        onClose();
      }}
      disableEscapeKeyDown
      aria-labelledby="recommended-target-group-missing-title"
      aria-describedby="recommended-target-group-missing-description"
      PaperProps={{
        sx: { borderRadius: '10px', padding: '16px', width: '500px' },
      }}
    >
      <DialogTitle
        id="recommended-target-group-missing-title"
        sx={{
          fontSize: '28px',
          fontWeight: 700,
          lineHeight: 1.2,
          color: theme.palette.error.main,
          whiteSpace: 'pre-line',
        }}
      >
        {t('mediaPlanning.modals.recommendedTargetGroupMissing.header')}
      </DialogTitle>

      <DialogContent>
        <DialogContentText
          id="recommended-target-group-missing-description"
          sx={{ color: '#525F81', fontWeight: 400 }}
        >
          <Typography whiteSpace="pre-line">
            {t('mediaPlanning.modals.recommendedTargetGroupMissing.text')}
          </Typography>
        </DialogContentText>
      </DialogContent>

      <DialogActions sx={{ gap: '1rem' }}>
        <Button
          onClick={onClose}
          variant="contained"
          size="large"
          sx={{
            backgroundColor: theme.palette.error.main,
            minWidth: '150px',
            height: '42px',
            borderRadius: 1,
            '&:hover': {
              backgroundColor: theme.palette.error.main,
            },
          }}
        >
          OK
        </Button>
      </DialogActions>
    </Dialog>
  );
}
